import { render } from "./home.vue?vue&type=template&id=25497258&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=25497258&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25497258"

export default script